import styled from "styled-components"
import {mainGreen} from "../../../styles/global/colors"

export const Wrapper = styled.div`
    width: 100%;
    height: auto;
    padding:30px 70px;
    margin-top:30px;
    margin-bottom:80px;
    font-family: Montserrat !important;
    .container4{
        position:relative;
        z-index:10;
    }
    @media (max-width: 760px){
        padding:30px 5px
    }
`
export const TitleContainer = styled.div`
    width: 100%;
    padding:15px 20px;
    background-color:${mainGreen};
    color:#fff;
`